var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('div',{staticClass:"WSpinner",class:_vm.spinnerClass},[_c('div',{staticClass:"dot1"}),_c('div',{staticClass:"dot2"})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }